import Recap from 'components/Content/Recap/Recap';
import RecapListConnect from 'viewModel/content/recapList/withRecapListProps';

export default RecapListConnect(Recap);
